// extracted by mini-css-extract-plugin
var _1 = "rlWvL2_XNBKZ9Ma2Gm5p";
export { _1 as "loading" }
